import {BaseAnalyticsEvent} from "../../../../infrastructure/models/analytics/base-analytics-event";
import {ANALYTICS} from "../../../../third-party-services/analytics/analytics-consts";

export class CompetitorPlayerStatsModuleStatsPlayerScrollEvent extends BaseAnalyticsEvent {
  gameId: Number;
  status: Number;
  athleteId: String;
  source: String;
  isHeatmap: Boolean;

  constructor(params) {
    super('', 'player-scroll', 'live-stats');

    this.gameId = params.gameId;
    this.status = params.status;
    this.athleteId = params.athleteId;
    this.source = params.source;
    this.isHeatmap = params.isHeatmap;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.athleteId = this.athleteId;
    properties.source = this.source;
    properties.isHeatmap = Number(this.isHeatmap);

    return properties;
  }
}